import React from "react";
import "./info-styles.css";
import "../theme/app-styles.css"

import { caretBack } from "ionicons/icons";

import {
  IonContent,
  IonPage,
  IonCard,
  IonCardTitle,
  IonCardHeader,
  IonCardContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,
} from "@ionic/react";

import Footer from "../components/Footer";

const Info: React.FC = () => {
  const infoCardText = {
    fontFamily: "'Quicksand', sans-serif",
    fontWeight: "300",
    fontSize: "max(calc(.5em + 1vw), 18px)",
    lineHeight: "normal",
    color: "white",
    textShadow: "1px 1px 2px black",
  };

  return (
    <IonPage className="info-page">
      <IonHeader >
        <IonToolbar color="primary"  className="info-page-header">
        <IonButtons slot="start">
            <IonBackButton defaultHref="/"   className="back-button" icon= {caretBack} text="">

            </IonBackButton>
    
          </IonButtons>
          <IonTitle className="ion-text-center">
           Important Information
          </IonTitle>
        
        </IonToolbar>
      </IonHeader>
      <IonContent className="background-image">
      <div className='content-container'>

            
<h1 className="text-title" id="about">About this year&apos;s program</h1>
<p className="body-text">Welcome to this year’s OCIA/Adult Sacramental Prep program for 2025-26!</p>
<p className="body-text" style={{ textDecoration: "underline" }}>This program is for:</p>
  <ul className="bullet-list">
    <li className="bullet-text">Non-Catholic adults wishing to join the Catholic Church (or interested in find out more about us).</li>
    <li className="bullet-text">Catholic adults wishing to complete their Sacraments (e.g., First Holy Communion and/or Confirmation).</li> 
    </ul> 
<p className="body-text">The program consists of two parallel tracks: </p>
<ul className="bullet-list">
    <li className="bullet-text">The <strong>Catechetical track</strong> consists of approximately 24 sessions
        (plus “mini-retreat”) that meets weekly beginning on September 2, 2025 and ending after Easter 2026.
        The meetings are held on Tuesday evenings each week in Dempsey Hall (under the Old Church at the corner of 15th Ave S and 8th St. S in Nampa) beginning at 7pm and lasting approximately two hours. 
        A session calendar will be available on July 21st. </li>
    <li className="bullet-text">The <strong>Liturgical track</strong> consists of several liturgical celebrations held (mostly) 
        during the season of Lent at either the Saturday 5pm Vigil Mass or the Sunday 10am Holy Mass and conclude with the reception of 
        the Sacraments on a Sunday during the Easter Season.  The track is
        different depending upon your situation. The calendar for these liturgical celebrations will be posted on July 21st.
    </li>
</ul>

</div>
        <section className="info-content-container">
          <h2 className="text-subtitle"> 1. Cost</h2>
          <p className="body-text">
            This program is offered free-of-charge. However, there is a
            non-refundable $40 Materials Fee to help cover the cost of books and
            handouts. The fee should be paid in class [Cash or check made out to
            St.Paul&apos;s Catholic Chruch] on or before September 16, 2025.
          </p>
        </section>
        <section className="info-content-container">
          <h2 className="text-subtitle"> 2. Sponsor</h2>

          <p className="body-text">
            Those who are to receive Sacraments in April 2026 will need to find
            a <em>sponsor</em>. A sponsor is a Catholic who can walk with you on
            your journey as you prepare to receive the spiritual gifts of the
            Sacraments. You should begin thinking about who this might be with
            the objective of choosing your sponsor before the middle of October.
            The requirements for a sponsor are listed below. If you do not have
            a sponsor, our catechist, Sandy Butler, can assist you in finding
            one.{" "}
          </p>
          <ul className="bullet-list">
            <li className="bullet-text">
              Must be 16 years or older, but preferably someone with lived
              experience as a Catholic adult for five or more years.
            </li>
            <li className="bullet-text">
              Must be a Catholic in good standing (e.g., attends Mass
              regularly).
            </li>
            <li className="bullet-text">
              Must have received their own Sacraments of Baptism, Holy Communion
              and Confirmation.
            </li>
            <li className="bullet-text">
              Either unmarried, or if married, his/her marriage must have been
              performed in a Catholic Church (or marriage was subsequently “blessed” (called
              “convalidation”) by the Church).
            </li>
            <li className="bullet-text">
              <strong>
                Must be able to attend the majority of the liturgical events in
                your Liturgical track!
              </strong>
            </li>
          </ul>
        </section>
        <section className="info-content-container">
          <h2 className="text-subtitle">3. Eligibility</h2>
          <p className="body-text">
            The Church delights in adding new members to its ranks and welcomes
            everyone. However, we cannot promise that you will receive your
            desired Sacraments next Spring.
          </p>
          <p className="body-text" style={{ paddingBottom: "10px", textDecoration: "underline" }}>
            There are several reasons why this might be the case:
          </p>

          <div className="info-container">
            <IonCard
              className="info-card"
              style={{ backgroundColor: "var(--kobicha)" }}
            >
              <IonCardHeader>
                <IonCardTitle className="info-card-title">
                  Participation
                </IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                <p style={infoCardText}>
                  In order to be considered eligible to receive the Sacraments,
                  you must participate in the Catechetical classes and the
                  Liturgical track events. We ask and expect participants to attend all the sessions, attend the required rituals, and 
                  complete and submit any requested paperwork in a reasonable
                  manner. We will work with those who have a schedule conflict
                  or who miss a session or two due to an emergency or
                  unavoidable personal conflict.
                </p>
              </IonCardContent>
            </IonCard>

            <IonCard
              className="info-card"
              style={{ backgroundColor: "var(--chamoisee)" }}
            >
              <IonCardHeader>
                <IonCardTitle className="info-card-title">
                  Readiness
                </IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                <p style={infoCardText}>
                  The Program’s Catechist team is tasked by the Pastor to represent to him, and to the parish, that an
                  individual wishing to receive the Sacraments is ready to do
                  so. The team makes this assessment based upon a discernment of
                  growth in the individual’s spiritual life, his or her participation
                  in the program, and his or her overall demeanor and attitude
                  toward the Faith. Assessments will be performed in November
                  and February.
                </p>
              </IonCardContent>
            </IonCard>

            <IonCard
              className="info-card"
              style={{ backgroundColor: "var(--tan)" }}
            >
              <IonCardHeader>
                <IonCardTitle className="info-card-title">
                  Marriage Situation
                </IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                <p style={infoCardText}>
                  Our Pastor is not allowed to administer
                  Sacraments to individuals unless their marriage situation aligns ( or
                  is on the path to align) with the Church’s Canon laws regarding
                  marriage. This can be somewhat complicated. Based upon
                  the information you provide on your registration form, we will
                  assess your personal situation and assist you in putting
                  together a plan to address any issues, if necessary.
                </p>
              </IonCardContent>
            </IonCard>
          </div>
        </section>
        <Footer />
      </IonContent>
    </IonPage>
  );
};

export default Info;
